/**
 * Centralized External Supabase configuration.
 *
 * Reads the External Supabase URL and anon key from Vite environment
 * variables so build/publish deployments can point the Driver App at a
 * different External Supabase project without code changes.
 *
 * Both variables MUST be defined at build time. If either is missing we
 * throw immediately at import time so the failure surfaces at app startup
 * rather than as a cryptic runtime error deep inside the Supabase client.
 */

const url = import.meta.env.VITE_EXTERNAL_SUPABASE_URL as string | undefined;
const anonKey = import.meta.env.VITE_EXTERNAL_SUPABASE_ANON_KEY as string | undefined;

if (!url || !anonKey) {
  const missing = [
    !url ? 'VITE_EXTERNAL_SUPABASE_URL' : null,
    !anonKey ? 'VITE_EXTERNAL_SUPABASE_ANON_KEY' : null,
  ]
    .filter(Boolean)
    .join(', ');
  throw new Error(
    `[externalSupabase] Missing required environment variable(s): ${missing}. ` +
      `Define them in .env before running \`bun run build\` or building the Capacitor Android app.`,
  );
}

export const EXTERNAL_SUPABASE_URL: string = url;
export const EXTERNAL_SUPABASE_ANON_KEY: string = anonKey;